import {ModuleWithProviders, NgModule, Optional, SkipSelf} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule} from "@angular/forms";
import {TreeViewItemComponent} from "./tree-view-item.component";
import {TreeViewComponent} from "./tree-view.component";
import {TreeViewListHeaderComponent} from "./tree-view-list-header.component";
import {IndeterminateCheckboxDirective} from "./indeterminate-checkbox.directive";
import {FormHelpersModule} from "../form-helpers/form-helpers.module";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    FormHelpersModule,
  ],
  declarations: [
    TreeViewComponent,
    TreeViewItemComponent,
    TreeViewListHeaderComponent,
    IndeterminateCheckboxDirective,
  ],
  exports: [
    TreeViewComponent,
  ],
})
export class TreeViewModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: TreeViewModule,
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: TreeViewModule) {
    if (parentModule) {
      throw new Error("TreeViewModule is already loaded. Import it in the main module only.");
    }
  }
}
